export default {"src":"/_next/static/media/grammar.3ac7c2d1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};